import React, { useEffect, useRef, useState } from 'react';
import '../../scss/reusables/descriptor.scss';
import  { CKEditor } from 'ckeditor4-react';
import { IoIosSend } from "react-icons/io";

export default function DiscussionDescriptor({ value, setvalue, users, post, readOnly, index = 0, other }) {
    const editorRef = useRef(null);
    const [inputValue, setInputValue] = useState(value);

    const handleEditorInit = (event) => {
        editorRef.current = event.editor;
        // if (inputValue) {
        //     event.editor.setData(inputValue);
        // }
    };

    // useEffect(() => {
    //     if (editorRef.current && inputValue !== editorRef.current.getData()) {
    //     editorRef.current.setData(inputValue || "");
    //     }
    // }, [inputValue]);
    return (
        <div className={!readOnly && `card shadow-sm mb-3 me-4 border`}>
            <div className={!readOnly && `card-body p-2 d-flex align-items-end`}>
                <div className={`${readOnly ? '' : `flex-grow-1 me-2`} descriptor-editor`}>
                <style>{`
                        .descriptor-editor .cke_top {
                            display: none !important;
                        }
                        .descriptor-editor .cke_bottom {
                            display: none !important;
                        }
                        .descriptor-editor .cke_chrome {
                            border: none !important;
                        }
                        .descriptor-editor .cke_contents {
                           font-family: Lato-Regular !important;
                        }
                    `}</style>

                    <CKEditor
                        key={users?.length > 0 ? `DiscussionEditor${users?.length}` : `Discussion`+index}
                        id={users?.length > 0 ? `DiscussionEditor${users?.length}` : `Discussion`+index}
                        initData={inputValue ? inputValue : ''}
                        config={{
                            readOnly: readOnly,
                            contentsCss: [
                                `body { background-color: ${readOnly ? other ? 'rgb(22, 140, 208, 0.14)' : '#FAFAFA' : ''}; font-family: sans-serif; }`,
                            ],
                            bodyClass: 'lato-font',
                            extraPlugins: "mentions, autogrow",
                            height: 'auto',
                            autoGrow_onStartup: true,
                            autoGrow_minHeight: 40,
                            autoGrow_maxHeight: 500,
                            mentions:[
                                {
                                    feed: (opts, callback) => {
                                        const matchProperty = "display";
                                        const query = (opts?.query || "").toString().toLowerCase();
                                        const data = users
                                        ?.filter((item) =>
                                            item[matchProperty].toLowerCase().startsWith(query)
                                        )
                                        .sort((a, b) =>
                                            a[matchProperty].localeCompare(b[matchProperty])
                                        );
                                        callback(data);
                                    },
                                    itemTemplate:
                                        '<li data-id="{id}">' +
                                        '<strong>{display}</strong>&nbsp;&nbsp;' +
                                        '</li>',
                                    outputTemplate: '<strong>@{display}</strong>&nbsp;',
                                    minChars: 0,
                                }
                            ],
                        }}
                        onBeforeLoad={(CKEDITOR) => {
                            CKEDITOR.disableAutoInline = true;
                        }}
                        onChange={(event) => {
                            const data = event.editor.getData();
                            setInputValue(data);
                        }}
                        onInstanceReady={handleEditorInit}
                    />
                </div>
                {!readOnly && <div className="d-flex align-items-center px-2 mb-2 text-primaryColor">
                        <IoIosSend style={{cursor: 'pointer'}} size={28} 
                            onClick={() => {
                                post(inputValue)

                                if (editorRef.current) {
                                    editorRef.current.setData('');
                                }

                                setInputValue('');    
                            }}
                        />
                    </div>}
            </div>
        </div>
    );
}